module.exports = __webpack_public_path__ + "img/mapOfficeDefault.d345d05.svg";